"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATC_GROUP_MIN_WIDTH = exports.ATC_GROUP_WIDTH = exports.ATC_X_PADDING = void 0;
exports.ATC_X_PADDING = 14;
exports.ATC_GROUP_WIDTH = 280;
exports.ATC_GROUP_MIN_WIDTH = 196;
//# sourceMappingURL=constants.js.map